import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { ApprovalStatus, ApprovalType } from '@/entities/approvals/constants';
import { id, links, meta, nullableUser, numberOrNull, stringOrNull, user } from '@/services/api';

export const inspectionApprovalCodec = t.type({
  id,
  status: t.keyof({
    [ApprovalStatus.Pending]: null,
    [ApprovalStatus.Approved]: null,
    [ApprovalStatus.Rejected]: null,
    [ApprovalStatus.ChangesRequested]: null,
  }),
  approver: nullableUser,
  comment: stringOrNull,
  updated_at: DateFromUnixTime,
});

export const approvalCodec = t.type({
  created_at: DateFromUnixTime,
  updated_at: DateFromUnixTime,
  type: t.keyof({
    [ApprovalType.Inspection]: null,
    [ApprovalType.Issue]: null,
  }),
  status: t.keyof({
    [ApprovalStatus.Pending]: null,
    [ApprovalStatus.Approved]: null,
    [ApprovalStatus.Rejected]: null,
    [ApprovalStatus.ChangesRequested]: null,
  }),
  inspection: t.union([
    t.type({
      id,
      done_by: stringOrNull,
      title: t.string,
    }),
    t.null,
  ]),
  issue: t.union([
    t.type({
      id,
      done_by: stringOrNull,
      title: t.string,
    }),
    t.null,
  ]),
  comment: stringOrNull,
  approver: nullableUser,
  approvers: t.union([t.null, t.array(user)]),
});

export const recordCodec = t.type({
  id,
  data: approvalCodec,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
  links,
});

export const formCodec = t.type({
  comment: stringOrNull,
  inspection: numberOrNull,
  issue: numberOrNull,
  type: t.keyof({
    [ApprovalType.Inspection]: null,
    [ApprovalType.Issue]: null,
  }),
  status: t.keyof({
    [ApprovalStatus.Approved]: null,
    [ApprovalStatus.Rejected]: null,
    [ApprovalStatus.ChangesRequested]: null,
    [ApprovalStatus.Pending]: null,
  }),
});
